import React from 'react';
import { fishingRod } from '../../../components/shared/vector-images';
import Text from '../../../components/shared/_deprecated/elements/Text/Text';
import {
  onInitializeStandardMarker,
  onToggleStandardMarker,
} from '../_helpers';

const layer = {
  displayName: 'Fishing spot',
  synonyms: '',
  group: 'standardMarker',
  typeUrl: 'fishing-spot',
  icon: {
    baseShape: fishingRod,
    iconColor: '#fff',
    markerColor: '#139ECA',
  },
  shownByDefault: true,
  relativeDepth: 0,
  menuOptions: {
    visible: true,
    owningMenu: 'marine-points-of-interest',
    order: 15,
  },
  standardMarkerOptions: {
    markerType: 'fishingLocationMarker',
    allowCreation: true,
    allowEditing: false,
    allowComments: true,
    viewOptions: {
      typeTitle: 'Fishing spot',
      itemTitleFunction: (item) => (item && item.title) || '',
    },
    creationOptions: {
      menuText: 'Fishing spot',
      newTitle: 'Fishing spot',
      titlePlaceholder: 'Name of fishing spot',
      markerTypeDescription: [
        <Text key="description-text-1" size="-1" paragraph>
          Include information such as type of ground, fish species, seasonality
          and other relevant details.
        </Text>,
        <Text key="description-text-2" size="-1" paragraph>
          Information provided should be factual. Once you submit this marker,
          you can add your personal experiences or questions as a comment
          underneath.
        </Text>,
      ],
      checkBoxItems: [],
    },
    editingOptions: {},
  },
  popOverConfiguration: (marker) => ({
    markerType: layer.standardMarkerOptions.markerType,
    id: marker.id,
    displayChat: true,
    displayUpVotes: true,
    title: 'Fishing spot',
    description: marker.title,
  }),
};

layer.onInitialize = onInitializeStandardMarker(layer);
layer.onToggle = onToggleStandardMarker(layer);

export default layer;
